import { TagInput } from '@/common/Tag/components/TagInput';
import { TagEntityType, TagItem } from '@/models/DTOs/ManageTypes/Requests';
import { useFormContext } from 'react-hook-form';
import { FC } from 'react';

interface Props {
  tags: TagItem[];
}

export const TimelineTagsForm: FC<Props> = ({ tags }) => {
  const { setValue } = useFormContext();
  return (
    <TagInput
      onChange={(values) => setValue('tags', values, { shouldDirty: true })}
      defaultValue={tags}
      entityType={TagEntityType.DRIVER}
      fetchOptions
    />
  );
};
